import type { GettextInterface } from '@indeed/indeed-gettext';

import {
    useApplyLinkLoading,
    useApplyLinkUrl,
    useViewjobOneGraphModel,
} from '../../../../context/ViewJobDataContext';

export const getInterviewNowButtonText = (i18n: GettextInterface) => {
    return i18n.gettext(
        // # Interview Now CTA - Button Text - Get connected online with an employer over video.
        'Get connected',
    );
};

export const getIndeedApplyButtonText = (i18n: GettextInterface) => {
    return i18n.gettext(
        // # Interview Now CTA - Secondary Apply Button Text - Apply to this job.
        'Apply now',
    );
};

export const useInterviewNow = () => {
    const viewjobOneGraphModel = useViewjobOneGraphModel();
    const applyLinkUrl = useApplyLinkUrl();
    const applyLinkLoading = useApplyLinkLoading();

    if (!viewjobOneGraphModel?.interviewNowModel) {
        return undefined;
    }

    // Keep this aligned with OGWrappedIndeedApplyButton: hiring events use an inline IA URL,
    // while OneGraph IA becomes actionable through the async apply-link loading/resolved states.
    const hasIndeedApply = !!viewjobOneGraphModel.indeedApplyButtonContainer &&
        (!!viewjobOneGraphModel.indeedApplyButtonContainer?.indeedApplyUrl ||
            applyLinkLoading ||
            !!applyLinkUrl);

    return hasIndeedApply ? viewjobOneGraphModel.interviewNowModel : undefined;
};
